import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const NodeRedWorkbenchOutlineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="NodeRedWorkbenchOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/node-red-workbench/outline">
            <path
                fill="none"
                id="Vector"
                d="M16.543 19H11.5287C11.2634 19 11.0091 18.8946 10.8216 18.7071C10.634 18.5196 10.4801 18.2652 10.4801 18V6C10.4801 5.73478 10.634 5.48043 10.8216 5.29289C11.0091 5.10536 11.2634 5 11.5287 5H14.545M10.4805 12H7.45898M14.554 7V3C14.554 2.44772 15.0017 2 15.554 2L19.554 2C20.1063 2 20.554 2.44772 20.554 3V7C20.554 7.55228 20.1063 8 19.554 8H15.554C15.0017 8 14.554 7.55228 14.554 7ZM16.541 21V17C16.541 16.4477 16.9887 16 17.541 16H21.541C22.0933 16 22.541 16.4477 22.541 17V21C22.541 21.5523 22.0933 22 21.541 22H17.541C16.9887 22 16.541 21.5523 16.541 21ZM1.45898 14L1.45898 10C1.45898 9.44772 1.9067 9 2.45898 9H6.45898C7.01127 9 7.45898 9.44772 7.45898 10V14C7.45898 14.5523 7.01127 15 6.45898 15H2.45898C1.9067 15 1.45898 14.5523 1.45898 14Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
            </path>
        </g>
    </SvgIcon>
)
